module.exports = __webpack_public_path__ + "static/media/default_user_profile_background.44dd258a.png";